import { render, staticRenderFns } from "./AdminReferralProgram.vue?vue&type=template&id=31473012&"
import script from "./AdminReferralProgram.vue?vue&type=script&lang=js&"
export * from "./AdminReferralProgram.vue?vue&type=script&lang=js&"
import style0 from "./AdminReferralProgram.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31473012')) {
      api.createRecord('31473012', component.options)
    } else {
      api.reload('31473012', component.options)
    }
    module.hot.accept("./AdminReferralProgram.vue?vue&type=template&id=31473012&", function () {
      api.rerender('31473012', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminReferralProgram.vue"
export default component.exports